import { render, staticRenderFns } from "./transcript-view.vue?vue&type=template&id=6accb7e6&"
import script from "./transcript-view.vue?vue&type=script&lang=js&"
export * from "./transcript-view.vue?vue&type=script&lang=js&"
import style0 from "./transcript-view.vue?vue&type=style&index=0&id=6accb7e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports